import { isArray } from 'lodash';

const question = (value) => (isArray(value) && value.length >= 3 ? {} : null);

export default question;
